import Tracker from "@openreplay/tracker";
import { Route, Routes } from "react-router-dom";
import CountrySetupModal from "./components/country-setup.modal";
import FooterComponent from "./components/Footer";
import Header from "./components/Header";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect } from "react";
import LandingPage from "./landing.page";
import LoginPage from "./pages/login.page";
import RefundPolicyPage from "./pages/refund-policy";
import RegisterVerifyPage from "./pages/register-verify";
import RegisterPage from "./pages/register.page";
import AuthProvider from "./providers/auth.provider";
import CurrencyProvider from "./providers/currency.provider";
import GroupProvider from "./providers/groups.provider";
import { AuthenticatedRoutes } from "./routes";
import TermsOfService from "./pages/terms";
let tracker: Tracker | null = null;

if (process.env.REACT_APP_OPEN_REPLAY_API_KEY) {
  tracker = new Tracker({
    projectKey: process.env.REACT_APP_OPEN_REPLAY_API_KEY!,
    ingestPoint: "https://replay.expensehut.com/ingest",
  });
}

const Main = () => {
  const skipSessionReplayLocalStorage =
    localStorage.getItem("x-exhut-skip-session-replay") === "true";

  useEffect(() => {
    if (tracker && !skipSessionReplayLocalStorage) {
      tracker
        .start()
        .then((sessionID) =>
          console.log("OpenReplay tracker started with session: ", sessionID),
        )
        .catch((err) => console.error("Error starting openreplay " + err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`app`}>
      <GoogleOAuthProvider
        clientId={process.env.REACT_APP_EXHUT_GOOGLE_CLIENT_ID!}
      >
        <AuthProvider>
          <CurrencyProvider>
            <GroupProvider>
              <Header />
              <CountrySetupModal />
              <Routes>
                <Route
                  path="/register/verify"
                  element={<RegisterVerifyPage />}
                />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/refund-policy" element={<RefundPolicyPage />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/" element={<LandingPage />} />
                <Route path="*" element={<AuthenticatedRoutes />} />
              </Routes>
              <FooterComponent />
            </GroupProvider>
          </CurrencyProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </div>
  );
};

export default Main;
